import React from 'react'
import Notification from '@ynap/notification'
import BEMHelper from '@ynap/bem-helper'
import { LineItem } from 'app/state/types'

export const getJITNotification: GetJitNotification = (messages, key, bem) => {
    if (!messages || messages.empty) return null
    const title = messages[key]?.title
    const message = messages[key]?.text

    return message ? (
        <div className={bem('jitContainer')}>
            <Notification className={bem('jit', 'side')} message={message} title={title} type="plain" parseMarkdown={true} />
        </div>
    ) : null
}

// split remote and local items into two arrays
export function splitRemoteItems(lineItemsIncludingRemoved: LineItem[] = []): Array<LineItem[]> {
    return (
        lineItemsIncludingRemoved?.reduce(
            (output: Array<LineItem[]>, item: LineItem) => {
                item?.isRemote ? output[0].push(item) : output[1].push(item)
                return output
            },
            [[], []]
        ) || []
    )
}

export function sortJITItemsToBottom(lineItemsIncludingRemoved: LineItem[]): LineItem[] {
    return lineItemsIncludingRemoved?.sort((item: LineItem) => (item.isJIT ? 1 : -1))
}

interface JitMessage {
    text?: string
    title?: string
    empty?: boolean
}

interface JitMessages {
    [key: string]: JitMessage
}

interface GetJitNotification {
    (messages: JitMessages, key: string, bem: BEMHelper, onClick?: () => void): JSX.Element | null
}
